module.exports = __webpack_public_path__ + "img/cxTrends-7.26c5060a.png";